import axios from "axios";

// Имэйлгүй хэрэглэгчийн e-Mongolia баталгаажуулалт — OAuth state ба session key
export const DAN_SETUP_STATE_KEY = "atlas_dan_setup_state";
export const DAN_SETUP_KEY = "atlas_dan_setup_key";

function randomState() {
  const bytes = new Uint8Array(32);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

export default {
  async getGrantUrl() {
    return axios.get("/api/enduser/dan/grant");
  },
  async getDanResult(token) {
    return axios.get(`/api/enduser/dan/token/result?access_token=${token}`);
  },

  // state-г энэ browser-т хадгалж e-Mongolia руу шилжүүлнэ
  async startVerify() {
    const state = randomState();
    sessionStorage.setItem(DAN_SETUP_STATE_KEY, state);
    sessionStorage.removeItem(DAN_SETUP_KEY);
    const { data } = await axios.get("/api/enduser/dan/verify/grant", {
      params: { state },
      noAuth: true,
    });
    window.location.href = data.url;
  },
  async exchangeSetupCode(code, state) {
    return axios.post("/api/enduser/dan/setup/exchange", { code, state }, { noAuth: true });
  },
  async getSetupStatus(key) {
    return axios.post("/api/enduser/dan/setup/status", { key }, { noAuth: true });
  },
  async sendSetupEmailOtp(key, email) {
    return axios.post("/api/enduser/dan/setup/email", { key, email }, { noAuth: true });
  },
  async confirmSetupEmailOtp(key, otp) {
    return axios.post("/api/enduser/dan/setup/email/confirm", { key, otp }, { noAuth: true });
  },
  async completeSetup(key, payload) {
    return axios.post("/api/enduser/dan/setup/complete", { key, ...payload }, { noAuth: true });
  },
};
